export enum TaskStatus {
    NotStarted = "not_started",
    Pending = "pending",
    Processing = "processing",
    Completed = "completed",
    Failed = "failed",
}

export interface Task {
    id: string;
    taskType: string;
    draftId: string;
    fileId: string;
    resultFileId: string;
    status: TaskStatus;
    errorMessage: string;
    startedAt: string;
    finishedAt: string;
}
